import * as ActionTypes from '../../actions/ActionTypes';
import CategoryDetailsRecord, { HomepageCategoryStateRecord } from '../../records/edit/CategoryDetailsRecord';
export default ((state = new HomepageCategoryStateRecord(), action) => {
  switch (action.type) {
    case ActionTypes.FETCH_CATEGORY_SUCCESS:
      {
        const {
          payload
        } = action;
        return state.merge({
          category: CategoryDetailsRecord.fromJS(payload),
          error: null,
          lastLoaded: Date.now(),
          isRequesting: false
        });
      }
    case ActionTypes.FETCH_CATEGORY_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_CATEGORY_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    default:
      return state;
  }
});